import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-Arrow-Down3",
  "use": "icon-Arrow-Down3-usage",
  "viewBox": "0 0 14 15",
  "content": "<symbol viewBox=\"0 0 14 15\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-Arrow-Down3\">\r\n<g id=\"icon-Arrow-Down3_&#228;&#184;&#139;&#230;&#139;&#137;&#230;&#140;&#137;&#233;&#146;&#174;\">\r\n<path id=\"icon-Arrow-Down3_Vector 117\" d=\"M4 6.5L7 9.5L10 6.5\" stroke=\"#6B6E75\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol